import moment from "moment";

export const columnDefs = [
  {
    checkboxSelection: true,
    width: 80,
    resizable: true,
  },
  {
    headerName: "id",
    field: "id",
    hide: true,
    editable: false,
    resizable: true,
  },
  {
    headerName: "parent_id",
    field: "parent_id",
    hide: true,
    editable: false,
    resizable: true,
  },
  {
    headerName: "iso3",
    field: "iso3",
    hide: true,
    editable: false,
    resizable: true,
  },
  {
    headerName: "event_name",
    field: "event_name",
    editable: true,
    resizable: true,
  },
  {
    headerName: "start_date",
    field: "start_date",
    valueFormatter: (params: any) => {
      const { value } = params;
      if (value && value !== "") {
        return moment(value).format("YYYY-MM-DD");
      } else {
        return "";
      }
    },
    cellEditor: "datePicker",
    editable: true,
    resizable: true,
  },
  {
    headerName: "end_date",
    field: "end_date",
    valueFormatter: (params: any) => {
      const { value } = params;
      if (value && value !== "") {
        return moment(value).format("YYYY-MM-DD");
      } else {
        return "";
      }
    },
    cellEditor: "datePicker",
    editable: true,
    resizable: true,
  },
  {
    headerName: "org_name",
    field: "org_name",
    editable: true,
    resizable: true,
  },
  {
    headerName: "org_accuracy",
    field: "org_accuracy",
    cellEditor: "agRichSelectCellEditor",
    cellEditorParams: {
      values: ["Admin0", "Admin1", "Admin2+"],
    },
    editable: true,
    resizable: true,
  },
  {
    headerName: "org_lat",
    field: "org_lat",
    editable: true,
    resizable: true,
    type: "numericColumn",
  },
  {
    headerName: "org_lon",
    field: "org_lon",
    editable: true,
    resizable: true,
    type: "numericColumn",
  },
  { headerName: "dst_name", field: "dst_name", editable: true },
  {
    headerName: "dst_accuracy",
    field: "dst_accuracy",
    cellEditor: "agRichSelectCellEditor",
    cellEditorParams: {
      values: ["Admin0", "Admin1", "Admin2+"],
    },
    editable: true,
    resizable: true,
  },
  {
    headerName: "dst_lat",
    field: "dst_lat",
    editable: true,
    resizable: true,
    type: "numericColumn",
  },
  {
    headerName: "dst_lon",
    field: "dst_lon",
    editable: true,
    resizable: true,
    type: "numericColumn",
  },
  {
    headerName: "stock_total",
    field: "stock_total",
    editable: true,
    resizable: true,
  },
  {
    headerName: "stock_male",
    field: "stock_male",
    editable: true,
    resizable: true,
  },
  {
    headerName: "stock_female",
    field: "stock_female",
    editable: true,
    resizable: true,
  },
  {
    headerName: "stock_in_camp",
    field: "stock_in_camp",
    editable: true,
    resizable: true,
  },
  {
    headerName: "stock_outside_camp",
    field: "stock_outside_camp",
    editable: true,
    resizable: true,
  },
  {
    headerName: "stock_age_cat_01",
    field: "stock_age_cat_01",
    editable: true,
    resizable: true,
  },
  {
    headerName: "stock_age_cat_02",
    field: "stock_age_cat_02",
    editable: true,
    resizable: true,
  },
  {
    headerName: "stock_age_cat_03",
    field: "stock_age_cat_03",
    editable: true,
    resizable: true,
  },
  {
    headerName: "new_total",
    field: "new_total",
    editable: true,
    resizable: true,
  },
  {
    headerName: "new_male",
    field: "new_male",
    editable: true,
    resizable: true,
  },
  {
    headerName: "new_female",
    field: "new_female",
    editable: true,
    resizable: true,
  },
  {
    headerName: "new_in_camp",
    field: "new_in_camp",
    editable: true,
    resizable: true,
  },
  {
    headerName: "new_outside_camp",
    field: "new_outside_camp",
    editable: true,
    resizable: true,
  },
  {
    headerName: "new_age_cat_01",
    field: "new_age_cat_01",
    editable: true,
    resizable: true,
  },
  {
    headerName: "new_age_cat_02",
    field: "new_age_cat_02",
    editable: true,
    resizable: true,
  },
  {
    headerName: "new_age_cat_03",
    field: "new_age_cat_03",
    editable: true,
    resizable: true,
  },
  {
    headerName: "returns_total",
    field: "returns_total",
    editable: true,
    resizable: true,
  },
  {
    headerName: "returns_male",
    field: "returns_male",
    editable: true,
    resizable: true,
  },
  {
    headerName: "returns_female",
    field: "returns_female",
    editable: true,
    resizable: true,
  },
  {
    headerName: "returns_in_camp",
    field: "returns_in_camp",
    editable: true,
    resizable: true,
  },
  {
    headerName: "returns_outside_camp",
    field: "returns_outside_camp",
    editable: true,
    resizable: true,
  },
  {
    headerName: "returns_age_cat_01",
    field: "returns_age_cat_01",
    editable: true,
    resizable: true,
  },
  {
    headerName: "returns_age_cat_02",
    field: "returns_age_cat_02",
    editable: true,
    resizable: true,
  },
  {
    headerName: "returns_age_cat_03",
    field: "returns_age_cat_03",
    editable: true,
    resizable: true,
  },
  {
    headerName: "returnees_total",
    field: "returnees_total",
    editable: true,
    resizable: true,
  },
  {
    headerName: "returnees_male",
    field: "returnees_male",
    editable: true,
    resizable: true,
  },
  {
    headerName: "returnees_female",
    field: "returnees_female",
    editable: true,
    resizable: true,
  },
  {
    headerName: "returnees_in_camp",
    field: "returnees_in_camp",
    editable: true,
    resizable: true,
  },
  {
    headerName: "returnees_outside_camp",
    field: "returnees_outside_camp",
    editable: true,
    resizable: true,
  },
  {
    headerName: "returnees_age_cat_01",
    field: "returnees_age_cat_01",
    editable: true,
    resizable: true,
  },
  {
    headerName: "returnees_age_cat_02",
    field: "returnees_age_cat_02",
    editable: true,
    resizable: true,
  },
  {
    headerName: "returnees_age_cat_03",
    field: "returnees_age_cat_03",
    editable: true,
    resizable: true,
  },
  {
    headerName: "house_destroyed",
    field: "house_destroyed",
    editable: true,
    resizable: true,
  },
  {
    headerName: "house_damaged",
    field: "house_damaged",
    editable: true,
    resizable: true,
  },
  {
    headerName: "url",
    field: "url",
    editable: true,
    resizable: true,
  },
];
